import { registerEnum } from '@cbbt/lib-interface';
var KapRole;
(function (KapRole) {
    KapRole["CHAIRPERSON"] = "CHAIRPERSON";
    KapRole["COMMITTEE_MEMBER"] = "COMMITTEE_MEMBER";
    KapRole["DIRECTOR"] = "Director";
    KapRole["PERSON_OF_SIGNIFICANT_CONTROL"] = "PSC";
    KapRole["RESPONSIBLE_FOR_MANAGING_FINANCES"] = "RESPONSIBLE_FOR_MANAGING_FINANCES";
    KapRole["SECRETARY"] = "SECRETARY";
    KapRole["SHAREHOLDER"] = "Shareholder";
    KapRole["TREASURER"] = "TREASURER";
    KapRole["ULTIMATE_BENEFICIAL_OWNER"] = "UBO";
})(KapRole || (KapRole = {}));
registerEnum(KapRole, 'KapRole');
export { KapRole };
//# sourceMappingURL=KapRole.js.map